/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  OTELMetricsPayload,
  OTELMetricsPayload$Outbound,
  OTELMetricsPayload$outboundSchema,
} from "../components/otelmetricspayload.js";

export type HooksNumberMetricsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type HooksNumberMetricsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  otelMetricsPayload: OTELMetricsPayload;
};

/** @internal */
export type HooksNumberMetricsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const HooksNumberMetricsSecurity$outboundSchema: z.ZodMiniType<
  HooksNumberMetricsSecurity$Outbound,
  HooksNumberMetricsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberMetricsSecurityToJSON(
  hooksNumberMetricsSecurity: HooksNumberMetricsSecurity,
): string {
  return JSON.stringify(
    HooksNumberMetricsSecurity$outboundSchema.parse(hooksNumberMetricsSecurity),
  );
}

/** @internal */
export type HooksNumberMetricsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  OTELMetricsPayload: OTELMetricsPayload$Outbound;
};

/** @internal */
export const HooksNumberMetricsRequest$outboundSchema: z.ZodMiniType<
  HooksNumberMetricsRequest$Outbound,
  HooksNumberMetricsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    otelMetricsPayload: OTELMetricsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      otelMetricsPayload: "OTELMetricsPayload",
    });
  }),
);

export function hooksNumberMetricsRequestToJSON(
  hooksNumberMetricsRequest: HooksNumberMetricsRequest,
): string {
  return JSON.stringify(
    HooksNumberMetricsRequest$outboundSchema.parse(hooksNumberMetricsRequest),
  );
}
